// webcomponents/site-footer.js
import { LitElement, html, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

const tailwindStyles = css`${unsafeCSS(COMPONENT_STYLES)}`;

class SiteFooter extends LitElement {
  static properties = {
    sitePath: { type: String },
    currentYear: { type: String },
  };

  static styles = tailwindStyles;

  constructor() {
    super();
    this.sitePath = '/';
    this.currentYear = new Date().getFullYear().toString();
  }

  render() {
    return html`
      <footer class="bg-slate-900 border-t border-slate-800 py-12 text-slate-400">
        <div class="container mx-auto px-4">
          <div class="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
            <div class="col-span-1 md:col-span-2">
              <a href="/" class="inline-block mb-4">
                 <span class="text-xl font-bold text-white">DashReply</span>
              </a>
              <p class="mb-4 max-w-md text-sm leading-relaxed">
                The AI Agent that turns your Spreadsheets into custom-persona responses on any platform. 100% human-mimicry. 100% account-safe. Stop typing, start Dashing.
              </p>
            </div>

            <div>
              <h4 class="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Legal</h4>
              <ul class="space-y-2 text-sm">
                <li><a href="${this.sitePath}/privacy" class="hover:text-white transition-colors">Privacy Policy</a></li>
                <li><a href="${this.sitePath}/terms" class="hover:text-white transition-colors">Terms of Service</a></li>
              </ul>
            </div>
            
            <div>
               <h4 class="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Product</h4>
               <ul class="space-y-2 text-sm">
                  <li><a href="/#cta-footer" class="hover:text-white transition-colors">Join Waitlist</a></li>
                  <!-- <li><a href="/docs" class="hover:text-white transition-colors">Docs</a></li> -->
               </ul>
            </div>
          </div>

          <div class="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs">
            <p class="mb-4 md:mb-0">
              © ${this.currentYear} DashReply. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    `;
  }
}

customElements.define('site-footer', SiteFooter);
